<template functional>
  <el-table-column
    v-if="data.attrs.children || data.attrs.filterRes.includes(data.attrs.label)"
    v-bind="data.attrs"
    :key="data.attrs.prop"
    :width="data.attrs.tableColumnWidthHistory[data.attrs.propColumnIndex[data.attrs.prop]] || data.attrs.width"
    :render-header="data.attrs.renderHeader"
  >
    <template v-if="data.attrs.children">
      <table-column
        v-for="column in data.attrs.children"
        :filterRes="data.attrs.filterRes"
        v-bind="column"
        :key="column.prop"
        :fixed="column.fixed || false"
        :sortable="column.sortable && 'custom'"
        :propColumnIndex="data.attrs.propColumnIndex"
        :tableColumnWidthHistory="data.attrs.tableColumnWidthHistory"
      >
        <template slot-scope="{scope, prop}">
          <slot v-bind="{scope, prop}"></slot>
        </template>
        <template slot-scope="scope" slot="header">
          <slot name="header" v-bind="scope"></slot>
        </template>
      </table-column>
    </template>
    <template slot-scope="scope" :slot="data.attrs.children ? null : 'default'">
      <slot v-bind="{scope, prop: data.attrs.prop}"></slot>
    </template>
    <template slot-scope="scope" slot="header">
      <slot name="header" v-bind="scope"></slot>
    </template>
  </el-table-column>
</template>

<script>
import tableColumn from './table-column'

export default {
  inheritAttrs: false,
  components: {
    tableColumn
  }
}
</script>